const mixinDayJs = {
    methods: {
        dateFormat(date, format) {
            return dayjs(date).format(format);
        },
        dateSetTime(date, hours, minutes, seconds = 0) {
            return dayjs(date).hour(hours).minute(minutes).second(seconds).millisecond(0);
        }

    }
}


const mixinErrorHandler = {
    data() {
        return {
            errors: []
        };
    },
    methods: {
        trackError(e, context, message) {
            if (e.message && e.message.constructor && e.message.constructor.name === 'Cancel') {
                return;
            }
            if (e.response) {
                if (e.response.data) {
                    let data = e.response.data;
                    message += ' Server error';
                    if (data.message) {
                        message += ': ' + data.message;
                    }
                    if (data.error && data.error.message) {
                        message += ': ' + data.error.message;
                    }
                }
                if (e.response.status) {
                    e.code = e.response.status;
                }
            }
            if (e.message) {
                message += ': ' + e.message;
            }

            if (_.isUndefined(context)) {
                context = null;
            }
            if (_.isUndefined(message)) {
                message = false;
            }
            let row = {
                error: e,
                type: 'error',
                context: context,
                message: message,
            };

            if (this.errors) {
                this.errors.push(row);
            }
            if (message) {
                console.log('tracked error', row);
            }
            if (this.$store) {
                this.$store.commit('add_message', row);
            } else {
                let errorMessage = row.message;
                if (!errorMessage) {
                    errorMessage = e.message;
                }
                console.log('error message', errorMessage);
                //alert(errorMessage);
            }
        },
        alertApiError(exception, api = null) {
            let additional = null;
            if (api && api.errors) {
                additional = api.errors;
            }
            console.log(exception);
            this.alert(`Fetch api urls failed: ${exception.message}`, 'danger', 'API error', true, additional);
        },
        alert(message, type = 'danger', title = '', critical= false, context = false, show = true) {
            let row = {
                type: type,
                message: message,
                show: show,
            };
            if (title) {
                row.title = title;
            }
            if (critical) {
                row.critical = critical;
            }
            if (context) {
                row.context = context;
            }
            if (this.$store) {
                this.$store.commit('add_message', row);
            }
        },
        checkNoError(response) {
            if (response.error) {
                if (response.response === 'error_validation') {
                    const errors = response.data;
                    let message = '';
                    _.each(errors, (e, field) => {
                        //message = message + '<strong>' + field + '</strong><br>';
                        _.each(e, (m) => {
                            message = message + m + '<br>';
                        })
                    });
                    this.alert(message, 'warning', response.error.message);
                } else {
                    this.alert(response.error.message, 'danger');
                }

                return false;
            }

            return true;
        },
    }
}


export {mixinDayJs, mixinErrorHandler};
